import Icon from '../components/Icon.vue'

Icon.register({
  'comment-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M64 240C64 289.6 85.4 335 121 370.7 108.4 421 66.7 465.9 66.2 466.5 64 468.8 63.4 472.2 64.7 475.2 66 478.1 68.8 480 72 480 138.3 480 188 448.2 212.6 428.6 245.3 440.9 281.6 448 320 448 347.4 448 373.7 444.4 398.4 438L72.9 186.4C67.3 203.5 64 221.4 64 240zM633.8 458.1L519.4 369.7C554.6 334.1 576 289.2 576 240 576 125.1 461.4 32 320 32 254.9 32 195.8 52.1 150.6 84.7L45.5 3.4C38.5-2 28.5-0.8 23 6.2L3.4 31.4C-2 38.4-0.8 48.4 6.2 53.8L594.6 508.5C601.6 513.9 611.6 512.7 617.1 505.7L636.7 480.4C642.1 473.6 640.8 463.5 633.8 458.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-slash.js
// module id = VgZF
// module chunks = 144